/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import ReviewControls from '../utils/ReviewControls';
import type Mithril from 'mithril';

export default function () {
	extend(DiscussionListItem.prototype, 'view', function (vnode) {
		const discussion = this.attrs.discussion;
		if (discussion.isReview()) {
			const discussionControls = DiscussionControls.controls(discussion, this);
			const reviewControls = ReviewControls.controls(discussion, this);
			discussionControls.merge(reviewControls);
			const controls = discussionControls.toArray();

			if (controls.length && vnode.children) {
				// The item's own vnode, whose first child is the controls dropdown.
				const dropdown = (vnode.children as Mithril.ChildArray)[0] as Mithril.Vnode;
				dropdown.children = controls;
			}
		}
	});
}
